import SelectComponent from '@components/inputs/select/Select.component';
import TextFieldComponent from '@components/inputs/textField/TextField.component';
import { Sizes } from '@constants/sizes.constants';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton, Stack } from '@mui/material';
import { AuditOfferResponseDto } from '@store/audits/audit-offer/audit-offer.model';
import { ServiceKindTypeEnum } from '@store/settings/serviceKinds';
import { checkIfErrors, FieldValidationType, getFieldError } from '@utils/yup.utils';
import { useTranslation } from 'react-i18next';
import { keyOfAuditOfferResponseData } from '../AddOffer.drawer';


interface AuditOfferProps {
    auditOffer: AuditOfferResponseDto | undefined;
    index: number;
    updateAuditOffer: (index: number, field: keyOfAuditOfferResponseData, value: AuditOfferResponseDto[keyOfAuditOfferResponseData]) => void;
    deleteAuditOffer: (idx: number, auditOffer: Partial<AuditOfferResponseDto>) => void;
    createOffer: (offer: Partial<AuditOfferResponseDto>) => void;
}
const Offer = (props: AuditOfferProps) => {
    const { auditOffer, updateAuditOffer, index, deleteAuditOffer, createOffer } = props;

    const errors ={
        type: getFieldError(auditOffer?.type, FieldValidationType.REQUIRED_STRING),
        price: getFieldError(auditOffer?.unitPriceInCents, FieldValidationType.REQUIRED_STRING)
    };

    const { t } = useTranslation();

    return (
        <Stack spacing={1.5}>
            <Stack spacing={1.5}>
                <SelectComponent
                    labelWidth={Sizes.drawerInputLabelWidth}
                    label={t('audits.audit-offer.type')}
                    placeholder={t('global.select')}
                    items={ServiceKindTypeEnum.selectItems()}
                    value={auditOffer?.type || ServiceKindTypeEnum.PICKUP}
                    handleChange={(type) => updateAuditOffer(index, 'type', type)}
                    required
                    error={errors.type}
                />
                {/*<TextFieldComponent*/}
                {/*    color="primary"*/}
                {/*    labelWidth={Sizes.drawerInputLabelWidth}*/}
                {/*    label={t('audits.audit-offer.price')}*/}
                {/*    placeholder={t('audits.audit-offer.price')}*/}
                {/*    value={String(auditOffer?.unitPriceInCents)}*/}
                {/*    handleChange={(newPrice) => updateAuditOffer(index, 'unitPriceInCents', newPrice)}*/}
                {/*    required*/}
                {/*    error={errors.price}*/}
                {/*/>*/}
                <TextFieldComponent
                    multiline
                    handleKeyPress={(evt) => {
                        if (((evt.target as any).value?.length ?? 0) >= 150) evt.preventDefault();
                    }}
                    rows={4}
                    placeholder={t('audits.audit-offer.comment')}
                    defaultValue={''}
                    value={auditOffer?.comment}
                    handleChange={(value) => updateAuditOffer(index, 'comment', value)}
                />
            </Stack>
            <Stack direction="row" justifyContent="flex-end" textAlign="right" spacing={2}>
                <Button variant="contained" color="primary"
                        onClick={() => createOffer(auditOffer as AuditOfferResponseDto)}
                        disabled={checkIfErrors(errors)}
                >
                    {auditOffer?.id ? t('global.modify') : t('global.add')}
                </Button>
                <IconButton onClick={() => deleteAuditOffer(index, auditOffer as AuditOfferResponseDto)}>
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </Stack>
    );
};


export default Offer;
